import React from 'react';
import PropTypes from 'prop-types';
import { cva } from 'class-variance-authority';
import { cn } from '~/lib/utils';

const badgeVariants = cva(
	'inline-flex items-center rounded-full border px-2.5 py-1 text-[0.7rem] font-semibold uppercase tracking-[0.18em] transition-colors',
	{
		variants: {
			variant: {
				default: 'border-primary/30 bg-primary/20 text-primary-foreground',
				secondary: 'border-border bg-secondary/70 text-secondary-foreground'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

function Badge({ className, variant, ...props }) {
	return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

Badge.propTypes = {
	className: PropTypes.string,
	variant: PropTypes.oneOf(['default', 'secondary'])
};

export { Badge, badgeVariants };
